module.exports = "/images/pancil_icon.svg?fbad36e2dea0fe20736f781778c4550d";